<template>
  <v-dialog v-model="dialog" persistent width="900" height="500" scrollable>
    <v-card>
      <v-card-title
        >Browse Plans
        <v-spacer />
        <v-btn icon color="red" @click="close" tile>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-tabs background-color="primary" dark show-arrows v-model="tab">
          <v-tab
            v-for="(tab, key) in tabs"
            @click="planlist = plans[tab]"
            :key="'tab' + key"
          >
            {{ tab }}
          </v-tab>
        </v-tabs>
        <v-card outlined tile>
          <v-data-table :headers="headers" :items="planlist">
            <template v-slot:item.rs="{ item }">
              <template v-if="type == 'dth'">
                <v-btn
                  depressed
                  v-for="(rs, key) in item.rs"
                  :key="key + rs"
                  dark
                  @click="select(rs)"
                  block
                  class="mb-2 mt-2"
                  small
                  color="primary"
                  >Rs {{ rs }} / {{ key }}</v-btn
                >
              </template>
              <v-btn
                depressed
                dark
                v-else
                @click="select(item.rs)"
                block
                class="mb-2 mt-2"
                small
                color="primary"
                >Rs {{ item.rs }}
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      plans: [],
      tab: 0,
      type: "dth",
      dialog: false,
      tabs: [],
      planlist: [],
    };
  },
  computed: {
    headers() {
      let list = [
        {
          text: "Plan Name",
          value: "plan_name",
          width: "150px",
          divider: true,
        },
        { text: "Description", value: "desc", divider: true },
        {
          text: "Last Update",
          value: "last_update",
          width: "120px",
          divider: true,
        },
        {
          text: "Rs",
          value: "rs",
          align: "left",
          width: "100px",
          sortable: false,
        },
      ];
      if (this.type == "prepaid") list.shift();
      return list;
    },
  },
  methods: {
    select(rs) {
      let vm = this;
      vm.dialog = false;
      vm.planlist = [];
      vm.plans = [];
      vm.$parent.form.amount = rs;
    },
    async initPrepaidPlan() {
      const vm = this;
      vm.type = "prepaid";
      let { provider, circle } = vm.$parent.form;
      let isProvider =
        provider instanceof Object == false || provider.Mplan_Code == undefined;
      if (isProvider) {
        vm.$alert.show("Please select the provider");
        return;
      }
      if (!circle) {
        vm.$alert.show("Please select the state");
        return;
      }
      let operator = provider.Mplan_Code;
      try {
        vm.$loader.show();
        let data = await vm.$store.dispatch("fetchPlan", {
          type: "prepaid",
          circle,
          operator,
        });
        let { records } = data;

        if (records instanceof Array != true) {
          vm.plans = records;
          vm.tab = 0;
          vm.tabs = [];
          Object.keys(records).forEach((key) => {
            vm.tabs.push(key);
          });
          vm.planlist = records[vm.tabs[0]];
          vm.dialog = true;
        } else {
          vm.$alert.show("Plan Not Available");
        }
        console.log(data);
        vm.$loader.hide();
      } catch (error) {
        console.log(error);
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    async init() {
      const vm = this;
      let { provider } = vm.$parent.form;
      let isProvider =
        provider instanceof Object == false || provider.Mplan_Code == undefined;
      if (isProvider) {
        vm.$alert.show("Please select the provider");
        return;
      }
      let operator = provider.Mplan_Code;
      try {
        vm.$loader.show();
        let data = await vm.$store.dispatch("fetchPlan", {
          offer: "roffer",
          type: "dth",
          operator,
        });
        let { records } = data;
        if (records["rs"] == undefined) {
          vm.plans = records;
          vm.tab = 0;
          vm.tabs = [];
          Object.keys(records).forEach((key) => {
            vm.tabs.push(key);
          });
          vm.planlist = records[vm.tabs[0]];
          vm.dialog = true;
        } else {
          vm.$alert.show(records.desc);
        }
        console.log(data);
        vm.$loader.hide();
      } catch (error) {
        console.log(error);
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    close() {
      let vm = this;
      vm.dialog = false;
      vm.plans = [];
      vm.planlist = [];
    },
  },
  mounted() {},
};
</script>
